module.exports = __webpack_public_path__ + "static/media/Ölpfützen feat Armin.d71d6db7.ogg";